import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import { withNamespaces } from "react-i18next";
import { ShieldUser, Timer, PenLine, X } from "lucide-react";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import AppHeader from '../containers/AppHeader'
import NmStepBar from '../components/NmStepBar'
import { postCancelPrebooking } from '../actions/qrs'

class PhoneView extends React.Component {
  constructor(props) {
    super(props)

    const prefill = props.location?.state || {};
    const prefillEmail = prefill.mail || '';
    this.state = {
      phoneNumber: prefill.phoneNumber || '',
      mail: prefillEmail,
      confirmMail: prefillEmail,
      confirmReservation: !!prefill.confirmReservation,
      idNumber: prefill.idNumber || '',
      isValidEmail: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(prefillEmail),
      minutes: 5,
      seconds: 0,
      isTimeUp: false,
      showExitDialog: false,
      pendingNavigation: null,
    }

    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
    this.handleMailChange = this.handleMailChange.bind(this);
    this.handleIdNumberChange = this.handleIdNumberChange.bind(this);
  }

  handlePhoneNumberChange(value, countryData) {
    let cleaned = value;
    if (countryData && countryData.dialCode) {
      const dc = countryData.dialCode;
      cleaned = cleaned.replace(/^\+/, '');
      if (cleaned.startsWith(dc) && cleaned.slice(dc.length).startsWith(dc)) {
        cleaned = cleaned.slice(dc.length);
      }
      const afterDc = cleaned.slice(dc.length);
      if (afterDc.startsWith('00' + dc)) {
        cleaned = dc + afterDc.slice(('00' + dc).length);
      }
      cleaned = cleaned.replace(/[^\d]/g, '');
    }
    this.setState({ phoneNumber: cleaned });
  }

  handleMailChange(event) {
    const mail = event.target.value;
    this.setState({ mail, isValidEmail: this.validateEmail(mail) });
  }

  handleConfirmMailChange = (event) => {
    this.setState({ confirmMail: event.target.value });
  }

  handleIdNumberChange(event) {
    this.setState({ idNumber: event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '') });
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  componentDidMount() {
    this.unblockHistory = history.block((location, action) => {
      this.setState({ showExitDialog: true, pendingNavigation: { location, action } });
      return false;
    });
    window.addEventListener('beforeunload', this.handleBeforeUnload);

    const { timeStamp } = this.props.location.state;
    if (timeStamp) this.startCountdown(timeStamp);
  }

  componentWillUnmount() {
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    if (this.countdownInterval) clearInterval(this.countdownInterval);
  }

  handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = '';
  }

  startCountdown(timeStamp) {
    const endTime = new Date(timeStamp).getTime() + 5 * 60 * 1000;
    this.countdownInterval = setInterval(() => {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        clearInterval(this.countdownInterval);
        this.setState({ minutes: 0, seconds: 0, isTimeUp: true });
        const { lockerAssigned, lockerMatricula, lockerMatrixId } = this.props.location.state;
        this.props.postCancelPrebooking({
          LockerAssigned: lockerAssigned,
          LockerMatricula: lockerMatricula,
          LockerMatrixId: lockerMatrixId,
        }).catch(console.error);
      } else {
        this.setState({
          minutes: Math.floor(diff / 60000),
          seconds: Math.floor((diff % 60000) / 1000),
        });
      }
    }, 250);
  }

  cancelPrebookingAndLeave = () => {
    const { lockerAssigned, lockerMatrixId, qr } = this.props.location.state;
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.props.postCancelPrebooking({ LockerAssigned: lockerAssigned, LockerMatrixId: lockerMatrixId })
      .finally(() => {
        const { pendingNavigation } = this.state;
        history.push(pendingNavigation ? pendingNavigation.location : `/qrsale/${qr}`);
      });
  }

  stayOnPage = () => this.setState({ showExitDialog: false, pendingNavigation: null });

  isContinueDisabled() {
    const requiresId = this.props.qrData?.requireIdNumber;
    return (
      this.state.phoneNumber.length < 6 ||
      !this.state.isValidEmail ||
      this.state.confirmMail !== this.state.mail ||
      !this.state.confirmReservation ||
      (requiresId && this.state.idNumber.length < 5)
    );
  }

  getTimerStyle() {
    const { minutes } = this.state;
    if (minutes < 1) return { background: 'linear-gradient(135deg, #dc2626, #ef4444)' };
    if (minutes < 2) return { background: 'linear-gradient(135deg, #d97706, #f59e0b)' };
    return null; // uses CSS default (customer gradient)
  }

  goTo() {
    if (this.isContinueDisabled()) return;
    const s = this.props.location.state;
    if (this.unblockHistory) this.unblockHistory();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.props.push('/PaymentView', {
      zoneSelected: s.zoneSelected,
      descriptionZone: s.descriptionZone,
      selectedAccessibility: s.selectedAccessibility,
      selectedLocker: s.selectedLocker,
      lockerPrice: s.lockerPrice,
      lockerAssigned: s.lockerAssigned,
      lockerPin: s.lockerPin,
      lockerMatricula: s.lockerMatricula,
      lockerCustomer: s.lockerCustomer,
      lockerCustomerID: s.lockerCustomerID,
      lockerMatrixId: s.lockerMatrixId,
      qr: s.qr,
      timeStamp: s.timeStamp,
      qrType: s.qrType,
      qrMode: s.qrMode,
      mail: this.state.mail,
      phoneNumber: this.state.phoneNumber,
      newsletterAcceptance: false,
      confirmReservation: this.state.confirmReservation,
      idNumber: this.state.idNumber,
      useRedsysInsite: this.props.qrData?.useRedsysInsite || false,
    });
  }

  render() {
    const { t, qrData } = this.props;
    const { minutes, seconds, isTimeUp } = this.state;
    const requiresId = qrData?.requireIdNumber;
    const urgent = minutes < 1;
    const warning = minutes < 2 && !urgent;

    const content = (
      <>
        {/* ── Countdown timer ── */}
        <div
          className={`nm-phone-timer${urgent ? ' nm-phone-timer-urgent' : warning ? ' nm-phone-timer-warning' : ''}`}
          style={this.getTimerStyle()}
        >
          <div className="nm-phone-timer-left">
            <Timer size={22} strokeWidth={1.8} />
            <span className="nm-phone-timer-label">{t("Tiempo para completar")}</span>
          </div>
          <span className="nm-phone-timer-count">
            {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
          </span>
        </div>

        {/* ── Header card ── */}
        <div className="nm-page-header-card">
          <div className="nm-page-header-card-text">
            <h3>{t("DATOS DE RESPALDO")}</h3>
            <span className="nm-page-header-zone">
              {t("Tu teléfono se vinculará a la taquilla reservada para poder recuperar el Pin")}
            </span>
          </div>
          <ShieldUser className="nm-form-icon" strokeWidth={1} />
        </div>

        {/* ── Form ── */}
        <div className="nm-form">

          {/* Email */}
          <div className="nm-uf-row">
            <div className="nm-uf-btn">
              <span className="nm-uf-label">{t('Email*')}</span>
              <input
                className="nm-input"
                name="lockerEmail"
                type="email"
                value={this.state.mail}
                onChange={this.handleMailChange}
                autoCapitalize="none"
                placeholder={t('Introduce tu email')}
              />
            </div>
          </div>

          {/* Confirm email */}
          <div className={`nm-uf-row${this.state.confirmMail.length > 0 && this.state.confirmMail !== this.state.mail ? ' nm-uf-row-error' : ''}`}>
            <div className="nm-uf-btn">
              <span className="nm-uf-label">{t('Confirmar Email*')}</span>
              <input
                className="nm-input"
                name="confirmMail"
                type="text"
                value={this.state.confirmMail}
                onChange={this.handleConfirmMailChange}
                autoCapitalize="none"
                autoComplete="off"
                placeholder={t('Repite tu email')}
                onPaste={e => e.preventDefault()}
              />
            </div>
            {this.state.confirmMail.length > 0 && this.state.confirmMail !== this.state.mail && (
              <span className="nm-uf-error">{t('Los emails no coinciden')}</span>
            )}
          </div>

          {/* Phone */}
          <div className="nm-uf-row">
            <div className="nm-uf-btn">
              <span className="nm-uf-label">{t('Teléfono*')}</span>
              <div className="nm-phone-input-wrap">
                <PhoneInput
                  country="es"
                  value={this.state.phoneNumber}
                  onChange={this.handlePhoneNumberChange}
                  pattern="[0-9]*"
                  placeholder={t('Introduce tu teléfono')}
                  countryCodeEditable={false}
                />
              </div>
            </div>
          </div>

          {/* ID (conditional) */}
          {requiresId && (
            <div className="nm-uf-row">
              <div className="nm-uf-btn">
                <span className="nm-uf-label">{t('Documento de Identidad*')}</span>
                <input
                  className="nm-input"
                  name="idNumber"
                  type="text"
                  value={this.state.idNumber}
                  onChange={this.handleIdNumberChange}
                  autoCapitalize="characters"
                  placeholder={t('DNI / NIE / Pasaporte')}
                  maxLength={20}
                />
              </div>
            </div>
          )}

          {/* Terms checkbox */}
          <div className="nm-checkbox">
            <input
              type="checkbox"
              id="confirmReservation"
              name="confirmReservation"
              checked={this.state.confirmReservation}
              onChange={() => this.setState({ confirmReservation: !this.state.confirmReservation })}
            />
            <label htmlFor="confirmReservation" className="nm-slider" />
            <label htmlFor="confirmReservation" className="nm-checkbox-label">
              {t('Confirmo que he leído y acepto los')}{' '}
              <a
                href="https://vacway.com/locker-terms.html"
                target="_blank"
                rel="noopener noreferrer"
                className="nm-terms-link"
              >
                {t('términos y condiciones')}
              </a>
            </label>
          </div>

          {/* Continue */}
          <div
            className={`nm-btn-continue${this.isContinueDisabled() ? ' disabled' : ''}`}
            onClick={() => this.goTo()}
          >
            {t("Continuar")}
          </div>

          {/* Privacy notice */}
          <p className="nm-phone-privacy">
            {t('*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo si el cliente no se suscribe a la newsletter.')}
          </p>
        </div>

        {/* ── Actions card ── */}
        <div className="nm-pay-actions-card">
          <p className="nm-pay-actions-hint">{t("¿Necesitas hacer algún cambio?")}</p>
          <div className="nm-pay-actions-row">
            <button className="nm-pay-action-edit" onClick={() => this.setState({ showExitDialog: true })}>
              <PenLine size={14} strokeWidth={2.2} />
              {t("Cambiar taquilla")}
            </button>
            <button className="nm-pay-action-cancel" onClick={() => this.setState({ showExitDialog: true })}>
              <X size={14} strokeWidth={2.2} />
              {t("Cancelar reserva")}
            </button>
          </div>
        </div>
      </>
    );

    return (
      <React.Fragment>
        <div className="normalBackground">
          <AppHeader />
          <div className="nm-page smartphone">
            {content}
            <NmStepBar step={3} />
          </div>
          <div className="nm-page pc">
            {content}
            <NmStepBar step={3} />
          </div>
        </div>

        {/* Time-up overlay */}
        {isTimeUp && (
          <div className="nm-exit-overlay">
            <div className="nm-exit-dialog">
              <div className="nm-exit-dialog-icon">⏰</div>
              <h4 className="nm-exit-dialog-title">{t('Tiempo de reserva agotado')}</h4>
              <p className="nm-exit-dialog-body">{t('Lo sentimos, pero no podemos reservar tu taquilla por más tiempo, otros usuarios deben poder acceder a ella. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.')}</p>
              <div className="nm-exit-dialog-actions">
                <button className="nm-exit-btn-leave" onClick={this.cancelPrebookingAndLeave}>
                  {t('Volver al inicio')}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Exit confirmation dialog */}
        {this.state.showExitDialog && (
          <div className="nm-exit-overlay">
            <div className="nm-exit-dialog">
              <div className="nm-exit-dialog-icon">⚠️</div>
              <h4 className="nm-exit-dialog-title">{t('¿Seguro que quieres salir?')}</h4>
              <p className="nm-exit-dialog-body">{t('Si abandonas ahora, tu taquilla reservada quedará libre y otro usuario podrá alquilarla.')}</p>
              <div className="nm-exit-dialog-actions">
                <button className="nm-exit-btn-stay" onClick={this.stayOnPage}>
                  {t('Continuar con el alquiler')}
                </button>
                <button className="nm-exit-btn-leave" onClick={this.cancelPrebookingAndLeave}>
                  {t('Cancelar y salir')}
                </button>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postCancelPrebooking: bindActionCreators(postCancelPrebooking, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PhoneView));
